import {useCustomMutate, useCustomQuery} from '../../../hooks/query';
import {
  getFeatureConfiguration,
  postCheckWindowPeriod,
  postConfigurationExam,
  postOpenPeriodConfig,
  putOpenPeriodConfig,
} from './api';
import {
  CONFIG_KEY_GET_CONFIGURATION_TYPE,
  CONFIG_KEY_POST_CHECK_OPEN_PERIOD_CONFIG,
  CONFIG_KEY_POST_CONFIGURATION_TYPE,
  CONFIG_KEY_POST_OPEN_PERIOD_CONFIG,
  CONFIG_KEY_PUT_OPEN_PERIOD_CONFIG,
} from './key';
import {ConfigurationType} from './model';


export const useFeatureConfigurationgQuery = () =>
    useCustomQuery<ConfigurationType[]>(
        CONFIG_KEY_GET_CONFIGURATION_TYPE,
        () => getFeatureConfiguration().then((res) => res.data),
        {
          refetchOnWindowFocus: false,
        }
    );

export const useRetrieveConfigurationExamList = (
    onSuccess: (res: any) => void,
    onError: (res: any) => void
) =>
    useCustomMutate(CONFIG_KEY_POST_CONFIGURATION_TYPE, postConfigurationExam, {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    });

export const useOpenPeriodConfig = (onSuccess: (res: any) => void, onError?: (res: any) => void) =>
    useCustomMutate(CONFIG_KEY_POST_OPEN_PERIOD_CONFIG, postOpenPeriodConfig, {
      onSuccess: (res) => onSuccess(res),
      onError,
    });

export const useUpdateOpenPeriodConfig = (
    onSuccess: (res: any) => void,
    onError: (res: any) => void
) =>
    useCustomMutate(CONFIG_KEY_PUT_OPEN_PERIOD_CONFIG, putOpenPeriodConfig, {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    });

export const useCheckWindowConfig = (onSuccess: (res: any) => void, onError: (res: any) => void) =>
    useCustomMutate(CONFIG_KEY_POST_CHECK_OPEN_PERIOD_CONFIG, postCheckWindowPeriod, {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    });
